import SectionHeader from "./SectionHeader";
import Reveal from "./Reveal";
import { Check, X } from "lucide-react";
import { BRAND } from "@/lib/brand";

const general = [
  "Many pest categories in one service",
  "Broad-spectrum treatment programs",
  "Generic, one-size-fits-all schedules",
  "Bed bugs added to a long list of pests",
  "General customer preparation guidance"
];
const ours = [
  "A service built for bed bugs only",
  "Treatment matched to the infestation",
  "Targeted application to bed bug harbourages",
  "Clear, specialized preparation guidance",
  "Follow-up arranged as part of the program"
];

export default function Difference() {
  return (
    <section id="difference" className="border-b border-border bg-background px-5 py-24 lg:px-8 lg:py-32">
      <div className="mx-auto max-w-7xl">
        <SectionHeader
          kicker="The Difference"
          title="ONE PROBLEM. ONE SPECIALTY."
          subtitle="Most pest-control companies maintain a long list of pests they treat. We chose a different direction. Bed bugs. Our service is built around treating bed bug infestations — not adding bed bugs to a generic list of pest-control services."
        />
        <div className="mt-16 grid items-stretch gap-4 lg:grid-cols-[1fr_auto_1fr]">
          <Reveal>
            <div className="flex h-full flex-col rounded-lg border border-border bg-muted/40 p-8">
              <span className="text-[11px] font-semibold uppercase tracking-[0.22em] text-muted-foreground">General Pest Control</span>
              <div className="my-6 h-px w-full bg-border" />
              <ul className="space-y-4">
                {general.map((g) => (
                  <li key={g} className="flex items-center gap-3 text-muted-foreground">
                    <span className="flex h-6 w-6 items-center justify-center rounded-full border border-border"><X className="h-3.5 w-3.5" /></span>
                    <span>{g}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
          <div className="flex items-center justify-center">
            <span className="font-heading text-sm font-bold uppercase tracking-[0.3em] text-accent lg:rotate-0">vs.</span>
          </div>
          <Reveal delay={0.1}>
            <div className="flex h-full flex-col rounded-lg border border-accent/30 bg-primary p-8 text-white">
              <span className="text-[11px] font-semibold uppercase tracking-[0.22em] text-accent">{BRAND.name} — Bed Bugs</span>
              <div className="my-6 h-px w-full bg-white/10" />
              <ul className="space-y-4">
                {ours.map((o) => (
                  <li key={o} className="flex items-center gap-3">
                    <span className="flex h-6 w-6 items-center justify-center rounded-full bg-accent text-white"><Check className="h-3.5 w-3.5" /></span>
                    <span>{o}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <p className="mt-12 max-w-3xl text-lg leading-relaxed text-muted-foreground">
            Bed bugs behave differently from other household pests — they hide deep in seams and crevices, travel between belongings and connected living environments, and rebound quickly when the obvious areas alone are treated. A specialist addresses the infestation as a bed bug problem, rather than another line item on a general pest-control list. That focus shapes how the treatment is planned, how it is carried out, and how the follow-up is arranged.
          </p>
        </Reveal>
      </div>
    </section>
  );
}